// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"11a0838a","453":"0d3f8c55","796":"6b9bce07"}[chunkId] + ".chunk.js";
};